import {ErrorCallout} from '/src/com/yext/listingslaunchstorm/js/enterprise/errorcallout/errorcallout';
import {FacebookConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/facebookconfiguration';
import {useSyncedFields} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/datasource/usesyncedfields';
import {useSyncedFieldSettings} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/datasource/usesyncedfieldsettings';
import {PageSkeleton} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/syncedfieldstable/pageskeleton';
import {SyncedFieldsTable} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/syncedfieldstable/syncedfieldstable';

/**
 * @param {{
 *   facebookConfiguration: FacebookConfiguration,
 *   setFacebookConfiguration: function(FacebookConfiguration): void,
 * }} props
 */
export function FacebookSyncedFields(props) {
  const syncedFieldSettingsState = useSyncedFieldSettings(559);
  const syncedFieldsState = useSyncedFields(559);

  function setSyncedFieldSettings(syncedFieldSettings) {
    const linkedAccount = props.facebookConfiguration.linkedAccount;
    const brandId = props.facebookConfiguration.brandId;
    const skipBrandId = props.facebookConfiguration.skipBrandId;
    const skipSetup = props.facebookConfiguration.skipSetup;
    props.setFacebookConfiguration(
      new FacebookConfiguration({
        linkedAccount,
        brandId,
        skipBrandId,
        skipSetup,
        syncedFieldSettings,
      }));
  }

  React.useEffect(() => {
    if (props.facebookConfiguration.syncedFieldSettings.length === 0) {
      if (syncedFieldSettingsState.data !== undefined) {
        setSyncedFieldSettings(syncedFieldSettingsState.data.settings);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncedFieldSettingsState.data]);

  if (syncedFieldSettingsState.status === 'error' || syncedFieldsState.status === 'error') {
    return <ErrorCallout onReload={() => {
      if (syncedFieldSettingsState.status === 'error') {
        syncedFieldSettingsState.refetch();
      }
      if (syncedFieldsState.status === 'error') {
        syncedFieldsState.refetch();
      }
    }}/>;
  }

  if (syncedFieldsState.data === undefined || syncedFieldSettingsState.data === undefined) {
    return <PageSkeleton />;
  }

  return (
    <SyncedFieldsTable
      syncedFields={syncedFieldsState.data.fields}
      syncedFieldSettings={props.facebookConfiguration.syncedFieldSettings}
      setSyncedFieldSettings={setSyncedFieldSettings}
    />
  );
}
